// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"9c44f5c5","514":"faf9fb9a","798":"769881bb","885":"a1725cd8"}[chunkId] + ".chunk.js";
};